export const activityFilters = [
  'All',
  'Label Print',
  'Sync',
];

export const dateFilters = [
  'Past Day',
  'Past Week',
  'Past Month',
  'Choose Dates',
];

export const resolveReasons = [
  'User Error',
  'Resolved In Oracle EBS',
  'Duplicate Transaction',
  'Other',
];

export const statusFilters = [
  'All',
  'Success',
  'Failed',
  'Pending',
  'Processing',
  'Resolved',
  'Submitted',
];

export const packSiteMapping = {
  'WM Morrisons Produce': ['CH1', 'FL1', 'TH1', 'RD1', 'GB1', 'ER1'],
  'Woodheads': ['CL1', 'SP1', 'TR1', 'TRF', 'SPL', 'CLN'],
  'Rathbones': ['WF1'],
  'International Seafoods': ['GY2'],
  'Simply Fresh': ['WS1'],
  'Farmers Boy Greenside': ['GS1'],
  'Farmers Boy Deeside': ['DS1'],
  'Farmers Boy Winsford': ['WN1'],
  'Lowlands': ['LL1'],
  'Flowerworld': ['FW1'],
};

export const SupplierId = {
  'PRD': [
    { displayName: '2725 - Produce', name: 'Produce', supplierId: '2725', type: 'new' },
    { displayName: '8600 - Produce', name: 'Produce', supplierId: '8600', type: 'old' },
  ],
  'WHD': [
    { displayName: '28213 - Colne', name: 'Colne', supplierId: '28213', type: 'new' },
    { displayName: '24110 - Turiff', name: 'Turiff', supplierId: '24110', type: 'new' },
    { displayName: '34516 - Spalding', name: 'Spalding', supplierId: '34516', type: 'new' },
    { displayName: '2329 - Colne', name: 'Colne', supplierId: '2329', type: 'old' },
    { displayName: '2321 - Spalding', name: 'Spalding', supplierId: '2321', type: 'old' },
    { displayName: '2325 - Turiff', name: 'Turiff', supplierId: '2325', type: 'old' },
  ],
  'RBL': [
    { displayName: '2745 - Wakefield', name: 'Wakefield', supplierId: '2745', type: 'new' },
    { displayName: '2868 - Wakefield', name: 'Wakefield', supplierId: '2868', type: 'old' },
  ],
  'ISL': [
    { displayName: '24518 - Lakeside', name: 'Lakeside', supplierId: '24518', type: 'new' },
    { displayName: '6994 - Lakeside', name: 'Lakeside', supplierId: '6994', type: 'old' },
  ],
  'SFL': [
    { displayName: '15346 - Worsley', name: 'Worsley', supplierId: '15346', type: 'new' },
    { displayName: '1217 - Worsley', name: 'Worsley', supplierId: '1217', type: 'old' },
  ],
  'FBG': [
    { displayName: '2639 - Greenside', name: 'Greenside', supplierId: '2639', type: 'new' },
    { displayName: '2645 - Greenside', name: 'Greenside', supplierId: '2645', type: 'new' },
    { displayName: '24305 - Greenside', name: 'Greenside', supplierId: '24305', type: 'new' },
    { displayName: '8803 - Greenside', name: 'Greenside', supplierId: '8803', type: 'old' },
    { displayName: '8807 - Greenside', name: 'Greenside', supplierId: '8807', type: 'old' },
    { displayName: '8800 - Greenside', name: 'Greenside', supplierId: '8800', type: 'old' },
  ],
  'FBD': [
    { displayName: '15318 - Deeside', name: 'Deeside', supplierId: '15318', type: 'new' },
    { displayName: '8811 - Deeside', name: 'Deeside', supplierId: '8811', type: 'old' },
  ],
  'FBW': [
    { displayName: '23028 - Winsford', name: 'Winsford', supplierId: '23028', type: 'new' },
    { displayName: '0253 - Winsford', name: 'Winsford', supplierId: '0253', type: 'old' },
  ],
  'LLN': [
    { displayName: '23979 - Lowlands', name: 'Lowlands', supplierId: '23979', type: 'new' },
    { displayName: '1208 - Lowlands', name: 'Lowlands', supplierId: '1208', type: 'old' },
  ],
  'FLW': [
    { displayName: '23974 - Flowerworld', name: 'Flowerworld', supplierId: '23974', type: 'new' },
    { displayName: '0636 - Flowerworld', name: 'Flowerworld', supplierId: '0636', type: 'old' },
  ],
};
